export const WHATSAPP_NUMBER = "919343716059";

export const categories = [
  { id: "all", label: "All Products" },
  { id: "perfect", label: "Perfect Diary" },
  { id: "project", label: "Project Diary" },
  { id: "wings", label: "Wings Diary" },
  { id: "span", label: "Span Diary" },
  { id: "club", label: "Club Diary" },
  { id: "notebook", label: "Notebooks" },
  { id: "embassy", label: "Embassy" },
];

export const products = [
  {
    id: "perfect-mesh-blue",
    name: "Perfect Diary - Mesh Blue",
    category: "perfect",
    categoryLabel: "Perfect Diary",
    size: "B5 (245 x 178 mm)",
    year: "2026",
    description: "B5-size eagle diary, easy to carry with Saturday and Sunday conveniently clubbed for a streamlined view.",
    features: ["Saturday & Sunday clubbed", "B5 compact size", "Premium mesh blue cover", "Gold foiling available"],
    images: ["/products/perfect-mesh-blue/1.png", "/products/perfect-mesh-blue/2.png"],
  },
  {
    id: "perfect-blue-wave",
    name: "Perfect Diary - Blue Wave",
    category: "perfect",
    categoryLabel: "Perfect Diary",
    size: "B5 (245 x 178 mm)",
    year: "2026",
    description: "B5-size eagle diary with elegant wave design. Saturday and Sunday clubbed for streamlined planning.",
    features: ["Elegant wave pattern", "Saturday & Sunday clubbed", "B5 portable format", "Personalisation ready"],
    images: ["/products/perfect-blue-wave/1.png", "/products/perfect-blue-wave/2.png", "/products/perfect-blue-wave/3.png"],
  },
  {
    id: "perfect-blue-hbx",
    name: "Perfect Diary - Blue HBX",
    category: "perfect",
    categoryLabel: "Perfect Diary",
    size: "B5 (245 x 178 mm)",
    year: "2026",
    description: "Premium HBX edition in blue. B5-size with Saturday & Sunday clubbed for a streamlined view.",
    features: ["HBX premium edition", "Saturday & Sunday clubbed", "Durable binding", "Custom embossing option"],
    images: ["/products/perfect-blue-hbx/1.png", "/products/perfect-blue-hbx/2.png", "/products/perfect-blue-hbx/3.png"],
  },
  {
    id: "perfect-brown",
    name: "Perfect Diary - Brown",
    category: "perfect",
    categoryLabel: "Perfect Diary",
    size: "B5 (245 x 178 mm)",
    year: "2026",
    description: "Classic brown edition of the Perfect Diary. B5-size with Saturday & Sunday clubbed.",
    features: ["Classic brown finish", "Saturday & Sunday clubbed", "B5 size for convenience", "Ideal for corporate gifts"],
    images: ["/products/perfect-brown/Layer 0.png", "/products/perfect-brown/perfect Brown 2.png"],
  },
  {
    id: "perfect-olive",
    name: "Perfect Diary - Olive",
    category: "perfect",
    categoryLabel: "Perfect Diary",
    size: "B5 (245 x 178 mm)",
    year: "2026",
    description: "Sophisticated olive edition. B5-size eagle diary with Saturday & Sunday clubbed.",
    features: ["Sophisticated olive tone", "Saturday & Sunday clubbed", "Premium paper quality", "Bulk order friendly"],
    images: ["/products/perfect-olive/1.png", "/products/perfect-olive/2.png", "/products/perfect-olive/3.png"],
  },
  {
    id: "perfect-icon-red",
    name: "Perfect Diary - Icon Red",
    category: "perfect",
    categoryLabel: "Perfect Diary",
    size: "B5 (245 x 178 mm)",
    year: "2026",
    description: "Bold icon red edition. B5-size eagle diary with Saturday & Sunday clubbed.",
    features: ["Bold red cover", "Saturday & Sunday clubbed", "Eye-catching design", "Page insertions available"],
    images: ["/products/perfect-icon-red/1.png", "/products/perfect-icon-red/2.png"],
  },
  {
    id: "perfect-hba-red",
    name: "Perfect Diary - HBA Red",
    category: "perfect",
    categoryLabel: "Perfect Diary",
    size: "B5 (245 x 178 mm)",
    year: "2026",
    description: "HBA Red variant with premium finish. B5-size with Saturday & Sunday clubbed.",
    features: ["HBA premium range", "Saturday & Sunday clubbed", "Red finish", "Personalised name option"],
    images: ["/products/perfect-hba-red/1.png", "/products/perfect-hba-red/2.png"],
  },
  {
    id: "perfect-hba-dual",
    name: "Perfect Diary - HBA Dual Tone",
    category: "perfect",
    categoryLabel: "Perfect Diary",
    size: "B5 (245 x 178 mm)",
    year: "2026",
    description: "Elegant dual-tone finish. B5-size eagle diary with Saturday & Sunday clubbed.",
    features: ["Unique dual-tone design", "Saturday & Sunday clubbed", "B5 size", "Executive appeal"],
    images: ["/products/perfect-hba-dual/1.png", "/products/perfect-hba-dual/2.png"],
  },
  {
    id: "project-blue",
    name: "Project Diary - Blue",
    category: "project",
    categoryLabel: "Project Diary",
    size: "245 x 178 mm",
    year: "2026",
    description: "Elegant design with ample writing space — ideal for capturing plans, ideas, and details that shape your day.",
    features: ["Ample writing space", "Project planning layout", "Elegant blue cover", "Gold foiling compatible"],
    images: ["/products/project-blue/1.png", "/products/project-blue/2.png", "/products/project-blue/3.png"],
  },
  {
    id: "project-red",
    name: "Project Diary - Red",
    category: "project",
    categoryLabel: "Project Diary",
    size: "245 x 178 mm",
    year: "2026",
    description: "Bold red edition blending elegant design with ample writing space for your daily plans and ideas.",
    features: ["Bold red cover", "Spacious daily pages", "Project management focused", "Custom branding available"],
    images: ["/products/project-red/2.png"],
  },
  {
    id: "wings-blue",
    name: "Wings Diary - Blue",
    category: "wings",
    categoryLabel: "Wings Diary",
    size: "A5 (210 x 150 mm)",
    year: "2026",
    description: "A5 diary perfectly sized for portability, with ample space to record more on every page.",
    features: ["A5 portable format", "Ample daily space", "Lightweight design", "Perfect for on-the-go"],
    images: ["/products/wings-blue/1.png", "/products/wings-blue/2.png"],
  },
  {
    id: "span-diary",
    name: "Span Diary 2026",
    category: "span",
    categoryLabel: "Span Diary",
    size: "A5 (210 x 150 mm)",
    year: "2026",
    description: "A5 diary perfectly sized for portability. Saturday & Sunday clubbed with ample space on every page.",
    features: ["A5 compact size", "Saturday & Sunday clubbed", "Daily planning sections", "Durable cover"],
    images: ["/products/span-diary/1.png", "/products/span-diary/2.png"],
  },
  {
    id: "club-diary",
    name: "Club Diary",
    category: "club",
    categoryLabel: "Club Diary",
    size: "245 x 178 mm",
    year: "2026",
    description: "For those who value fewer, fuller entries that capture the entire experience — the perfect choice.",
    features: ["Weekly overview format", "Fuller writing space", "Premium binding", "Corporate favourite"],
    images: ["/products/club-diary/1.png", "/products/club-diary/1.2.png"],
  },
  {
    id: "slim-notebook",
    name: "Slim Authority Notebook",
    category: "notebook",
    categoryLabel: "Notebooks",
    size: "165 x 92 mm",
    year: "Undated",
    description: "Versatile note-keeping without the constraint of dates. Record information freely.",
    features: ["Undated format", "Slim & pocket-friendly", "Versatile usage", "Professional design"],
    images: ["/products/slim-notebook/1.png", "/products/slim-notebook/2.png"],
  },
  {
    id: "custom-notebook",
    name: "Custom Notebook",
    category: "notebook",
    categoryLabel: "Notebooks",
    size: "Custom Sizes",
    year: "Custom",
    description: "Fully customisable notebooks for your brand. Choose cover, paper, layout, and binding.",
    features: ["Fully customisable", "Custom cover design", "Choose paper quality", "Min. order 2000 pcs"],
    images: ["/products/custom-notebook/1.png", "/products/custom-notebook/2.png", "/products/custom-notebook/3.png"],
  },
  {
    id: "embassy",
    name: "Embassy Diary",
    category: "embassy",
    categoryLabel: "Embassy",
    size: "245 x 178 mm",
    year: "2026",
    description: "Premium Embassy edition diary with refined finish, ideal for corporate gifting.",
    features: ["Premium finish", "Executive format", "Ideal for gifting", "Bulk customisation available"],
    images: ["/products/embassy/1.png", "/products/embassy/2.png", "/products/embassy/3.png"],
  },
  {
    id: "embassy-blue",
    name: "Embassy Diary - Blue",
    category: "embassy",
    categoryLabel: "Embassy",
    size: "245 x 178 mm",
    year: "2026",
    description: "Blue edition of the Embassy diary. Refined and elegant for the modern professional.",
    features: ["Blue refined cover", "Executive format", "Elegant design", "Logo embossing ready"],
    images: ["/products/embassy-blue/1.png", "/products/embassy-blue/2.png", "/products/embassy-blue/3.png"],
  },
];
